 
import baseApp from "../innerAPP";
import App from "./App";
const vm = baseApp(App);
vm.mount("#app");
